import React from "react";
import { Link } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import {
  ShowChart,
  Description,
  GetApp,
} from "@material-ui/icons";

import {useProvider} from "../Context";

function ListItemLink(props) {
  return <ListItem button component={Link} {...props} />;
}

function getQSAddedURL(url) {
  const context = useProvider();
  return url + "?activeMediaGroup=" + context.auth.state.activeMediaGroup;
}

export default function MediaSideMenu() {
  return (
    <div>
      <ListItemLink to={getQSAddedURL("/media/dashboard")}>
        <ListItemIcon>
          <ShowChart />
        </ListItemIcon>
        <ListItemText primary="ダッシュボード" />
      </ListItemLink>
      <ListItemLink to={getQSAddedURL("/media/medias")}>
        <ListItemIcon>
          <Description />
        </ListItemIcon>
        <ListItemText primary="全ての投稿" />
      </ListItemLink>
      <ListItemLink to={getQSAddedURL("/media/download")}>
        <ListItemIcon>
          <GetApp />
        </ListItemIcon>
        <ListItemText primary="データダウンロード" />
      </ListItemLink>
    </div>
  );
}
